import { render, staticRenderFns } from "./Minedata.vue?vue&type=template&id=4b81f0ee&scoped=true"
import script from "./Minedata.vue?vue&type=script&lang=js"
export * from "./Minedata.vue?vue&type=script&lang=js"
import style0 from "./Minedata.vue?vue&type=style&index=0&id=4b81f0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81f0ee",
  null
  
)

export default component.exports